module.exports = __webpack_public_path__ + "html/subscription-invoice-history-table_168e75b0bfaafa93f628ab1f8b0feb42.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-invoice-history-table.html
// module id = H4F6
// module chunks = 55